<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style lang="scss">
@import url('./styles/app.scss');
</style>
